module.exports = __webpack_public_path__ + "img/BR.90669d2b.webp";